/**
 * pdf.js worker URL. Webpack copies `pdf.worker.<version>.map-upsert.min.mjs`
 * and injects `__PDFJS_WORKER_FILE__`. The name is part of the path because
 * `s3sync.sh` caches that object for a year; a fixed name keeps the previous
 * worker after a pdfjs upgrade (`API version does not match the Worker version`).
 */
function pdfWorkerSrc() {
  /* eslint-disable camelcase -- webpack runtime global and DefinePlugin */
  const publicPath = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : '/';
  const workerFile =
    typeof __PDFJS_WORKER_FILE__ === 'string' ? __PDFJS_WORKER_FILE__ : 'pdf.worker.min.mjs';
  /* eslint-enable camelcase */
  return `${publicPath}${workerFile}`;
}

export default pdfWorkerSrc();
